import axios from "axios";
import { toast } from "react-toastify";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    console.log(error);

    toast("An unexpected error occured");
  }

  return Promise.reject(error);
});

function setRequestInterceptor(interceptorBefore, interceptorAfter) {
  axios.interceptors.request.use(interceptorBefore, interceptorAfter);
}

function setJwt(jwt) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
  setRequestInterceptor
};
